import { FC } from 'react'

import {
  GreyGrey30,
  GreyWhite,
  RichTextEditor,
  Box,
  Flex
} from '@sequencehq/core-components'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import { Config } from '.'
import { REMINDER_NODE_TEMPLATE_VARIABLES } from './reminder.constants'

export const ReminderExpandedContent: FC<{ nodeId: string }> = ({ nodeId }) => {
  const { nodeData } = useNode<Config>({ nodeId })

  if (!nodeData) return null

  return (
    <Flex
      data-testid="automations.editor.reminder.expandedContent"
      flexDir="column"
      width="320px"
      maxW="100%"
    >
      <Flex
        overflow="hidden"
        borderY={`${GreyGrey30} 1px solid`}
        paddingY="6px"
      >
        <RichTextEditor
          content={nodeData.subject}
          variant="SINGLE_LINE"
          variables={REMINDER_NODE_TEMPLATE_VARIABLES}
          formattingEnabled={false}
          outputFormat="TEXT"
          readOnly
        />
      </Flex>

      <Flex
        position="relative"
        height="166px"
        width="100%"
        overflow="hidden"
        borderBottom={`${GreyGrey30} 1px solid`}
        pointerEvents="none"
        paddingY="6px"
        sx={{
          '.tiptap': {
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': { display: 'none' }
          }
        }}
      >
        <RichTextEditor
          content={nodeData.template}
          variables={REMINDER_NODE_TEMPLATE_VARIABLES}
          readOnly
        />
        <Box
          position="absolute"
          bottom="0"
          left="0"
          right="0"
          height="96px"
          background={`linear-gradient(to bottom, transparent, ${GreyWhite})`}
        />
      </Flex>
    </Flex>
  )
}
